function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M271 64.8V64c0-8.8-6.8-16-15-16s-15 7.2-15 16v.7c-108 8-192.8 103.7-192.8 222 0 .4-.2.8-.2 1.3h3.2c6.4-23 26.2-39.8 49.6-39.8 23.3 0 43 16.9 49.5 39.8h4.9c6.4-23 26.4-39.8 49.8-39.8 18.4 0 35 10.5 44 26.3V424c0 13.2-11 24-24.2 24s-24.1-10.8-24.1-24c0-4.4-3.6-8-8.1-8-4.4 0-8 3.6-8 8 0 22.1 18.2 40 40.2 40s40.2-17.9 40.2-40V275.2c9-16.2 25.3-27 44-27 23.3 0 42.8 16.9 49.3 39.8h4.9c6.4-23 26.2-40 49.6-40 23.5 0 43.4 16.9 49.7 40h1.6C462.1 171.4 378 73.2 271 64.8z"
});

const SvgIosUmbrella = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosUmbrella, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-umbrella.6519382e.svg";
export { ForwardRef as ReactComponent };